import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Stories from "@/pages/stories/page";
import StoryDetail from "@/pages/stories/detail/page";
import Knowledge from "@/pages/knowledge/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "stories", element: <Stories /> },
      { path: "stories/:id", element: <StoryDetail /> },
      { path: "knowledge", element: <Knowledge /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;